import { createStyles } from "./styling";

const useStyles = createStyles(({ css, token }) => ({
  brand: css`
    align-items: center;
    color: ${token.colorPrimary};
    display: inline-flex;
    font-weight: 760;
    gap: 10px;
    letter-spacing: -0.02em;
  `,
  wordmark: css`
    color: ${token.colorText};
    font-size: 19px;
  `,
}));

export function BrandMark({
  compact = false,
  onDark = false,
}: {
  compact?: boolean;
  onDark?: boolean;
}) {
  const { cx, styles, theme } = useStyles();
  const wordColor = onDark ? "#ffffff" : theme.colorText;
  return (
    <span aria-label="Ark" className={cx(styles.brand)}>
      <svg
        aria-hidden="true"
        fill="none"
        height="30"
        viewBox="0 0 32 32"
        width="30"
      >
        <rect fill="currentColor" height="32" rx="9" width="32" />
        <path
          d="M9 22.5 15.8 8l7.2 14.5h-4.1l-1.25-2.8h-4.1l1.45-3.4h1.15l-.5-1.25-3.1 7.45H9Z"
          fill="#ffffff"
        />
      </svg>
      {!compact && (
        <span className={styles.wordmark} style={{ color: wordColor }}>
          Ark
        </span>
      )}
    </span>
  );
}
